import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { gettoken } from '../../Localstorage/Store';
export const saveCartApi = createApi({
  reducerPath: 'saveCartApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_API_URL}`, prepareHeaders: (headers, { getState }) => {
      const tokenvalue = gettoken();
      if (tokenvalue) {
        headers.set('Authorization',`Bearer ${tokenvalue.access}`);
      }
      return headers;
    },}),
  endpoints: (builder) => ({
    getSaveCart: builder.query({
      query: ({id}) => ({
        url: `my_api/get-single_order/${id}`,
        method:'GET'
      }),
      providesTags: ['savecart']
    }),
    getSaveCartCredit: builder.query({
      query: ({id}) => ({
        url: `credit/credit-total-save/${id}`,
        method:'GET'
      })
    }),
    postApplyCredit: builder.mutation({
        query: ({id,body}) => ({
          url: `credit/credit-apply-save/${id}/`,
          method:'POST',
          body
        })
      }),
    postPaymentDone: builder.mutation({
        query: (body) => ({
          url: `my_api/payment-done/`,
          method:'POST',
          body
        }),
        invalidatesTags: ['savecart']
      }),
  }),
})

export const { useGetSaveCartQuery,useGetSaveCartCreditQuery,usePostApplyCreditMutation,usePostPaymentDoneMutation } = saveCartApi